import { Button, Card, Divider, Icon } from '@blueprintjs/core';
import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../stores';
import SidebarArrowButton from '../../elements/SidebarArrowButton';
import SidebarButton from '../../elements/SidebarButton';
import useLogout from '../../hooks/useLogout';
import styles from './sidebar.module.css';

interface SidebarProps {
  collapsed?: boolean,
  onCollapse: () => void,
  /** Tampil di dalam drawer mobile: tanpa tombol collapse, dengan info akun & log out. */
  mobile?: boolean,
}

const Sidebar: React.FC<SidebarProps> = ({ collapsed, onCollapse, mobile }) => {
  const { user } = useSelector((s: RootState) => s.user);
  const logout = useLogout();

  return (
    <Card className={[styles.root, mobile && styles.mobile].filter(Boolean).join(' ')} elevation={1}>
      {mobile && (
        <div className={styles.account}>
          <Icon icon="user" />
          <span>{user.name}</span>
        </div>
      )}
      <div className={styles.menu}>
        <SidebarButton collapse={collapsed} href="#/dashboard" icon="home">
          Beranda
        </SidebarButton>
        <SidebarButton collapse={collapsed} href="#/permohonan" icon="add">
          Buat permohonan
        </SidebarButton>
        <SidebarButton collapse={collapsed} href="#/tinjauan" icon="th-list">
          Pengajuan saya
        </SidebarButton>
        <SidebarButton collapse={collapsed} href="#/form" icon="map">
          Formulir & peta
        </SidebarButton>
        <SidebarButton collapse={collapsed} href="#/bantuan-page" icon="headset">
          Bantuan
        </SidebarButton>
      </div>

      <div className={styles.footer}>
        <Divider style={{ margin: 0 }} />

        {mobile ? (
          <div className={styles.logout}>
            <Button fill minimal alignText="left" icon="log-out" text="Log out" onClick={logout} />
          </div>
        ) : (
          <div className={styles.collapseRow}>
            <SidebarArrowButton
              icon={collapsed ? 'double-chevron-right' : 'double-chevron-left'}
              onClick={onCollapse}
              ali="left"
              label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
            >
              {collapsed ? ' ' : 'Collapse'}
            </SidebarArrowButton>
          </div>
        )}
      </div>
    </Card>
  );
};

export default Sidebar;
